import PropTypes from 'prop-types';
import React, { Fragment, useEffect } from 'react';
import classNames from 'classnames';
import { once } from 'lodash';
import Button from '@xanadu/ui-shared/components/widgets/Button';

import { track } from '@xanadu/ui-shared/interfaces/woopra';

import IconCheck from '../../../../images/icons/misc/check.svg';

import useMarketingConsentReminder from './hooks/useMarketingConsentReminder';

import styles from './MarketingReminderPopup.module.scss';

const trackLoadOnlyOnce = once(() => {
  track('Marketing', 'Betslip Reminder - Marketing Consent - Show');
});

const ReminderPopup = ({
  dismissMarketingConsentReminder,
  setShowMarketingConsentReminder,
  updateMarketingConsent
}) => {
  const {
    optIn,
    success,
    error,
    loading
  } = useMarketingConsentReminder(setShowMarketingConsentReminder, updateMarketingConsent);

  const onReminderClose = () => {
    dismissMarketingConsentReminder();
    track('Marketing', 'Betslip Reminder - Marketing Consent - Hide');
  };

  const mainClass = classNames({
    [styles.main]: true,
    [styles['main--success']]: success,
    [styles['main--error']]: !!error,
  });

  useEffect(() => {
    trackLoadOnlyOnce();
  }, []);

  return (
    <div className={mainClass}>
      {success ? (
        <Fragment>
          <p>Thank you. You are now opted-in.</p>
          <IconCheck className={styles.icon} />
        </Fragment>
      ) : (
        <Fragment>
          {error ? (
            <p>{error}</p>
          ) : (
            <p>
              {'Customers who opt-in to marketing communications receive 67% more bonuses and free bets.'}
              <br />
              <br />
              {"Don't miss out!"}
            </p>
          )}
          <div className={styles.actions}>
            <button
              className={styles.secondaryButton}
              onClick={onReminderClose}
            >
              Hide this message
            </button>
            <Button
              className={styles.button}
              loading={loading}
              sizeType="small-mobile"
              buttonType="primary"
              onClick={optIn}
            >
              OPT IN
            </Button>
          </div>
        </Fragment>
      )}
    </div>
  );
};

ReminderPopup.propTypes = {
  dismissMarketingConsentReminder: PropTypes.func.isRequired,
  setShowMarketingConsentReminder: PropTypes.func.isRequired,
  updateMarketingConsent: PropTypes.func.isRequired,
};

export default ReminderPopup;
